const { Dashboard_service } = require('../services/Dashboard.service')
const { Report_promotion_service } = require('../services/Report_promotion_service')
const { Manage_internet_service } = require('../services/Manage_internet_service')
const moment = require('moment')
import { MessageBox } from 'element-ui'

const state = {
    provider_id: null,
    provider_type: null,
    provider_name: null,
    provider_list: {
        topView: []
    },
    month_th: [ "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน ", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม" ],
    short_month_th: ["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],
    service_type : {
        mobile : "โทรศัพท์เคลื่อนที่",
        broadband : "อินเทอร์เน็ตความเร็วสูงประจำที่"
    },
    report_type : {
        price : "ค่าบริการเหมาจ่าย (บาท)",
        download_speed : "ความเร็วดาวน์โหลด (Mbps)",
        upload_speed : "ความเร็วอัปโหลด (Mbps)",
        usage : "ปริมาณผู้ใช้งานแพ็กเกจ (ราย)",
        viewer : "ปริมาณผู้เข้าชม (ครั้ง)",
        voice_amount : "ปริมาณการโทร (นาที)",
        sms_amount : "ปริมาณการส่งข้อความ SMS (ข้อความ)",
        mms_amount : "ปริมาณการส่งรูปภาพ MMS (ข้อความ)",
        internet_mb : "ปริมาณอินเทอร์เน็ต (MB)",
        internet_gb : "ปริมาณอินเทอร์เน็ต (GB)",
        voice_avg : "อัตราค่าบริการเฉลี่ยบริการเสียง (บาท/นาที)",
        sms_avg : "อัตราค่าบริการเฉลี่ยบริการส่งข้อความ (บาท/ข้อความ)",
        mms_avg : "อัตราค่าบริการเฉลี่ยบริการส่งรูปภาพ (บาท/ข้อความ)",
        internet_avg : "อัตราค่าบริการเฉลี่ยบริการอินเทอร์เน็ต (บาท)",
        voice_fee : "อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการเสียง (บาท/นาที)",
        sms_fee : "อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการส่งข้อความ (บาท/ข้อความ)",
        mms_fee : "อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการส่งรูปภาพ (บาท/ข้อความ)",
        internet_fee : "อัตราค่าบริการส่วนเกินตามสิทธิ์การใช้งานบริการอินเทอร์เน็ต (บาท/MB)"
    },
    report_unit : {
        mobile : {
            price : "บาท",
            download_speed : "Mbps",
            usage : "ราย",
            viewer : "ครั้ง",
            voice_amount : "นาที",
            sms_amount : "ข้อความ",
            mms_amount : "ข้อความ",
            internet_mb : "MB",
            internet_gb : "GB",
            voice_avg : "บาท/นาที",
            sms_avg : "บาท/ข้อความ",
            mms_avg : "บาท/ข้อความ",
            internet_avg : "บาท/MB",
            voice_fee : "บาท/นาที",
            sms_fee : "บาท/ข้อความ",
            mms_fee : "บาท/ข้อความ",
            internet_fee : "บาท/MB"
        },
        broadband : {
            price : "บาท",
            download_speed : "Mbps",
            upload_speed : "Mbps",
            usage : "ราย",
            viewer : "ครั้ง",
            internet_avg : "บาท/Mbps"
        }
    },
    decimal : {
        'Kbps': 3,
        'Mbps': 2
    },
    behavior_chart: {},
    ranking_chart: {},
    topView_chart: {},
    G12_chart: {},
    monthly_table: [],
    monthly_total: 0,
    prototype: {
        packedbubble: {
            chart: {
                type: 'packedbubble'
            },
            title: {
                text: ''
            },
            tooltip: {},
            plotOptions: {
                packedbubble: {
                    minSize: '20%',
                    maxSize: '100%',
                    zMin: 0,
                    zMax: 1000,
                    layoutAlgorithm: {
                        gravitationalConstant: 0.05,
                        splitSeries: true,
                        seriesInteraction: false,
                        dragBetweenSeries: false,
                        parentNodeLimit: false
                    },
                    dataLabels: {
                        enabled: true,
                        format: '{point.name}',
                        style: {
                            color: 'black',
                            textOutline: 'none',
                            fontWeight: 'normal'
                        },
                        // filter: {
                        //     property: 'y',
                        //     operator: '>',
                        //     value: 0
                        // },
                    }
                }
            },
            series: [],
            credits: {
                enabled: false
            },
            exporting: {
                enabled : false
            }
        },
        column: {
            chart: {
                type: 'column',
                options3d: {
                    enabled: true,
                    alpha: 15,
                    beta: 15,
                    depth: 50,
                    viewDistance: 25
                }
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: ['Jan'],
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'จำนวนรายการส่งเสริมการขาย'
                }
            },
            plotOptions: {
                series: {
                    depth: 25,
                    colorByPoint: true
                }
            },
            series: [{
                data: [],
                name: 'Column',
                dataLabels: {
                    enabled: true,
                    rotation: -90,
                    color: '#FFFFFF',
                    align: 'right',
                    format: '{point.y}', // one decimal
                    y: 10, // 10 pixels down from the top
                    style: {
                        fontSize: '13px',
                        fontFamily: 'Verdana, sans-serif'
                    }
                }
            }],
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            }
        },
        bar: {
            chart: {
                type: 'bar',
                options3d: {
                    enabled: true,
                    alpha: 0,
                    beta: 0,
                    depth: 50,
                    viewDistance: 25
                }
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                crosshair: true,
                title: {
                    text: ''
                }
            },
            yAxis: {
                title: {
                    text: 'จำนวนครั้งที่เข้าชม'
                },
                labels: {
                    step: 5
                }
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                series: {
                    depth: 25,
                    colorByPoint: true
                }
            },
            series: [{
                data: [],
                name: 'Column',
                showInLegend: false
            }],
            credits: {
                enabled: false
            },
            exporting: {
                enabled: false
            }
        },
        line: {
            chart: {
                type: 'spline'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            xAxis: {
                categories: ['Jan'],
                crosshair: true
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'จำนวนรายการส่งเสริมการขาย'
                }
            },
            legend: {
                enabled: false
            },
            plotOptions: {
                series: {
                    depth: 25,
                    colorByPoint: true
                }
            },
            series: [{
                data: [],
                name: 'Column',
                showInLegend: false
            }],
            credits: {
                enabled: false
            },
            exporting: {
                enabled : false
            }
        },
        pie: {
            chart: {
                type: 'pie'
            },
            title: {
                text: ''
            },
            subtitle: {
                text: ''
            },
            series: [{
                name: 'จำนวนการค้นหา',
                colorByPoint: true,
                data: [],
                showInLegend: true,
                allowPointSelect: true
            }],
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        formatter: function() {
                            return '<b>'+ this.point.name +'</b> (' + this.point.percentage.toFixed(2) + '%)'
                        }
                    },
                    showInLegend: true
                }
            },
            tooltip: {
                formatter: function() {
                    return '<b>' + this.point.name + '</b><br>จำนวนการค้นหา: <b>' + formatNumber(this.y) + '</b> ครั้ง';
                }
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled : false
            }
        },
    },
    cr_table: [],
    cr_status:{
        request : 'ส่งคำร้อง',
        approve_request : 'ยืนยันคำร้อง',
        reject_request : 'ปฏิเสธคำร้อง',
        waiting : 'รอการตรวจสอบ',
        approve_edit : 'ยืนยันการแก้ไข',
        reject_edit : 'ปฏิเสธการแก้ไข'
    }
}

const actions = {
    async get_user_info({commit}){
        let result = await Manage_internet_service.get_user_info()
        if(result.status === 200){
            commit('SET_PROVIDER_ID',result.data.result[0].company_provider_id)
            commit('SET_PROVIDER_TYPE',result.data.result[0].provider_type)
            commit('SET_PROVIDER_NAME',result.data.result[0].provider_name)
        }else{
            MessageBox.confirm(result.message, 'ไม่พบข้อมูลผู้ใช้งาน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async set_provider_topview({commit}, providers) {
        commit('SET_PROVIDER_LIST_TOPVIEW', providers)
    },
    async getCurrentMonthlyRegulate({commit}, formdata) {
        let result = await Manage_internet_service.getCurrentMonthlyRegulate(formdata)
        commit('SET_MONTHLY_TABLE', result.data)
    },
    async setBehaviorChart({commit}, formdata) {
        if (formdata.provider_type == 'mobile') {
            let result = await Dashboard_service.behaviorMobileSearch(formdata);
            result.type_data = formdata.type_data;
            if (result.status == 200) {
                if (formdata.search_type == 'promotion_category') {
                } else if (formdata.search_type == 'provider_id') {
                } else if (formdata.search_type == 'min_price') {
                } else if (formdata.search_type == 'max_price') {
                } else if (formdata.search_type == 'voice_minute_amount') {
                } else if (formdata.search_type == 'voice_minute_price') {
                } else if (formdata.search_type == 'internet_amount') {
                } else if (formdata.search_type == 'internet_price') {
                } else if (formdata.search_type == 'internet_speed') {
                } else if (formdata.search_type == 'number_of_service_days') {
                    result = formatNumberService(result);
                } else if (formdata.search_type == 'privilege') {
                    result = formatPrivilege(result);
                    var sortable = [];
                    for (var data in result.data) {
                        sortable.push([result.data[data], result.data[data].amount]);
                    }
                    if (formdata.order == 'ASC') {
                        sortable.sort(function(a, b) {
                            return a[1] - b[1];
                        });
                    } else {
                        sortable.sort(function(a, b) {
                            return b[1] - a[1];
                        });
                    }
                    for(let i = 0; i < sortable.length; i ++){
                        result.data[i] = sortable[i][0]
                    }
                }
                let chart_data = { 
                    data: result.data
                }
                commit('SET_PIE_DATA', chart_data);
                // commit('SET_COLUMN_DATA', chart_data);
            } else {
                MessageBox.confirm(result.message, 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                })
            }
        } else {
            let result = await Dashboard_service.behaviorBroadbandSearch(formdata);
            result.type_data = formdata.type_data;
            if (result.status == 200) {
                if (formdata.search_type == 'promotion_category') {
                } else if (formdata.search_type == 'provider_id') {
                } else if (formdata.search_type == 'min_price') {
                } else if (formdata.search_type == 'max_price') {
                } else if (formdata.search_type == 'download_speed') {
                } else if (formdata.search_type == 'upload_speed') {
                } else if (formdata.search_type == 'service_on_top') {
                    result = formatService(result);
                } else if (formdata.search_type == 'privilege') {
                    result = formatPrivilege(result);
                    var sortable = [];
                    for (var data in result.data) {
                        sortable.push([result.data[data], result.data[data].amount]);
                    }
                    if (formdata.order == 'ASC') {
                        sortable.sort(function(a, b) {
                            return a[1] - b[1];
                        });
                    } else {
                        sortable.sort(function(a, b) {
                            return b[1] - a[1];
                        });
                    }
                    for(let i = 0; i < sortable.length; i ++){
                        result.data[i] = sortable[i][0]
                    }
                }
                let chart_data = { 
                    data: result.data
                }
                commit('SET_PIE_DATA', chart_data);
                // commit('SET_COLUMN_DATA', chart_data);
            } else {
                MessageBox.confirm(result.message, 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                })
            }
        }
    },
    async setRankingChart({commit}, formdata) {
        let result = formdata.service_type == 'mobile' ? await Report_promotion_service.getMobileRanking(formdata) : await Report_promotion_service.getBroadbandRanking(formdata)
        if(result.status == 200) {
            let qrydata = result.data
            let obj = {}
            obj.title = "รายงานจัดอันดับรายการส่งเสริมการขาย"+state.service_type[formdata.service_type]
            obj.subtitle = "ประเภท เปรียบเทียบ"+state.report_type[formdata.report_type]
            obj.categories = []
            obj.seriesName = state.report_type[formdata.report_type]
            obj.seriesData = []
            obj.seriesDetail = []
            obj.yAxis = {
                title: {
                    text: state.report_unit[formdata.service_type][formdata.report_type]
                }
            }
            for(let item of qrydata){
                obj.categories.push(item.promotion_code)
                obj.seriesData.push({y:item.amount, label:item.promotion_name_th})
                obj.seriesDetail.push(item.promotion_name_th)
            }
            obj.minHeight = formdata.limit*18
            commit('SET_COLUMN_CHART', obj)
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
              confirmButtonText: 'ตกลง',
              showCancelButton: false,
              type: 'warning'
            })
        }
    },
    async setTopViewChart({commit}, formdata) {
        let result = formdata.provider_type == 'mobile' ? await Report_promotion_service.getTopViewMobile(formdata) : await Report_promotion_service.getTopViewBroadband(formdata)
        if(result.status == 200) {
            let qrydata = result.data
            let obj = {}
            obj.title = ""
            obj.categories = []
            obj.seriesData = []
            obj.seriesDetail = []
            obj.yAxis = {
                title: {
                    text: 'จำนวนครั้งที่เข้าชม'
                },
                labels: {
                    step: 5
                }
            }
            obj.xAxis = {
                title: {
                    text: 'รหัสรายการส่งเสริมการขาย'
                }
            }
            for(let item of qrydata){
                obj.categories.push(item.promotion_code)
                obj.seriesData.push({y:item.amount, label:item.promotion_name_th})
                obj.seriesDetail.push(item.promotion_name_th)
            }
            obj.minHeight = formdata.limit*18
            commit('SET_BAR_CHART', obj)
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async setG12Chart({ commit,state }, data) {
        let start = moment(new Date()).set('date', 1).subtract(1, 'Y').format('YYYY-MM-DD')
        let end = moment(new Date()).set('date', 1).subtract(1, 'd').format('YYYY-MM-DD')
        data.daterange = {
          start : start,
          end : end
        }
        data.service_status = ['S','U','CS','CU']
        let opers = await Dashboard_service.getOperatorByType({provider_type : 'broadband'})
        let result = await Dashboard_service.getBroadbandAvgAll(data)
        if(result.status === 200){
          let top_title = ""
          let left_title = "บาท / "+data.service_rate
          let milestone = []
          let service_rate = data.service_rate == 'Kbps' ? 1000 : 1
          let series = []
          for(let provider of opers.data){
            let name = provider.provider_name
            let color = provider.provider_color
            let item_group = [provider.id]
            let provider_data = result.data.filter(item => item_group.includes(item.provider_id))
            let chartdata = []
            for(let date = moment(start) ; date <= moment(end) ; date = moment(date).add(1,'M')){
              milestone.push(state.short_month_th[date.month()]+'-'+moment(date).add(543,'Y').format('YY'))
              let datedata = provider_data.filter(item => moment(item.monthly_regulate).format('MM-YYYY') == moment(date).format('MM-YYYY'))
              if(datedata.length){
                let temp = 0
                for(let i = 0 ; i < datedata.length ; i++){
                  temp += datedata[i].internet_per_Mbps
                }
                let avg = parseFloat(temp/datedata.length/service_rate) != 0 ? parseFloat(((temp/datedata.length)/service_rate).toFixed(state.decimal[data.service_rate])) : null
                chartdata.push(avg)
              }else{
                chartdata.push(null)
              }
            }
            if(Math.max(...chartdata) > 0){
                series.push({
                    name : name,
                    data : chartdata,
                    color : color
                })
            }
          }
          let obj = {
            series: series,
            top_title: top_title,
            left_title: left_title,
            milestone: milestone,
            decimal: state.decimal[data.service_rate] 
          }
          commit('SET_LINE_CHART', obj)
        }
    },
    async getAllRequestByStatus({commit}, formdata){
        let result = await Dashboard_service.getAllRequestByStatus(formdata)
        if(result.status === 200){
            commit('SET_CR_TABLE', result.data)
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    }

}

const mutations = {
    SET_PROVIDER_ID(state,id){
        state.provider_id = id
    },
    SET_PROVIDER_TYPE(state,type){
        state.provider_type = type
    },
    SET_PROVIDER_NAME(state,name){
        state.provider_name = name
    },
    SET_PROVIDER_LIST_TOPVIEW(state, providers){
        state.provider_list.topView = providers
    },
    SET_PIE_DATA(state, obj){
        let pie = JSON.parse(JSON.stringify(state.prototype.pie));
        let other = 0
        for (let i = 0; i < obj.data.length; i++) {
            if(i < 9) {
                let data = {
                    name: formatNumber(obj.data[i].name),
                    y: obj.data[i].amount,
                    color: obj.data[i].color ? obj.data[i].color : "",
                    unit: obj.unit
                }
                pie.series[0].data.push(data)
            } else {
                other += obj.data[i].amount
            }
        }
        if (other > 0) {
            let data = {
                name: 'others',
                y: other
            }
            pie.series[0].data.push(data)
        }
        pie.plotOptions = {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    formatter: function() {
                        return '<b>'+ this.point.name +'</b> (' + this.point.percentage.toFixed(2) + '%)'
                    }
                },
                showInLegend: true
            }
        },
        pie.tooltip = {
            formatter: function() {
                return '<b>' + this.point.name + '</b><br>จำนวนการค้นหา: <b>' + formatNumber(this.y) + '</b> ครั้ง';
            }
        },
        state.behavior_chart = pie
    },
    SET_PACKEDBUBBLE_CHART(state, obj) {
        state.behavior_chart = {}
        let packedbubble = JSON.parse(JSON.stringify(state.prototype.packedbubble))
        packedbubble.series = []
        for (let i = 0; i < obj.length; i++) {
            packedbubble.series.push(obj[i])
        }
        packedbubble.tooltip = {
            useHTML: true,
            formatter: function() {
                return '<b>' + this.series.name + '</b><br>' + this.point.name + ': <b>' + formatNumber(this.point.value) + '</b> ครั้ง';
            }
        }
        state.behavior_chart = packedbubble;
    },
    SET_COLUMN_CHART(state, obj) {
        state.ranking_chart = {}
        let column = state.prototype.column
        column.legend = {}
        column.xAxis ={
            title: {
                text: obj.seriesData.length != 0 ? 'รหัสรายการส่งเสริมการขาย' : '',
                offset: 100,
                y: 30
            },
            categories: obj.categories
        }
        column.yAxis = {
          title : {
            text : obj.seriesData.length != 0 ? obj.yAxis.title.text : '',
            offset: 70
          },
          labels: {
            formatter: function() {
              return formatNumber(this.value);
            }
          }
        }
        column.series = [{
          name : obj.seriesName,
          data : obj.seriesData,
          points : obj.seriesDetail,
          showInLegend: false
        }]
        column.tooltip = {
          formatter: function() {
              return '<b>' + formatNumber(this.y) + ' ' + obj.yAxis.title.text + '</b><br><b>' + this.point.label + '</b>';
          }
        }
        column.chart.scrollablePlotArea = {
          minHeight: obj.minHeight
        }
        state.ranking_chart = column
    },
    SET_BAR_CHART(state, obj) {
        state.topView_chart = {}
        let bar = JSON.parse(JSON.stringify(state.prototype.bar))
        bar.legend.enabled = false
        bar.title.text = obj.title
        bar.subtitle.text = obj.subtitle
        bar.xAxis = obj.xAxis
        bar.xAxis.categories = obj.categories
        bar.xAxis = {
            title: {
                text: obj.xAxis.title.text,
                align: 'high',
                offset: -100,
                rotation: 0,
                y: 0
            },
            categories: obj.categories,
        }
        bar.yAxis = {
          title : {
            text : obj.yAxis.title.text
          },
          labels: {
            format: "{value: .0f}",
            step: 2
          }
        }
        // obj.seriesData.filter(data => data.y > 10).length == 0 ? bar.yAxis.tickInterval = 1 : bar.yAxis.tickInterval = 10
        bar.series = [{
          name : obj.seriesName,
          data : obj.seriesData,
          points : obj.seriesDetail
        }]
        bar.tooltip = {
          formatter: function() {
              return '<b>' + this.point.label + ' ' + obj.yAxis.title.text  + '</b><br><b>' + this.y + ' ครั้ง</b>';
          }
        }
        bar.chart.scrollablePlotArea = {
          minHeight: obj.minHeight
        }
        state.topView_chart = bar
    },
    SET_LINE_CHART(state, obj) {
        state.G12_chart = {
            chart:{
              type : 'spline'
            },
            title: {
                text: ''
            },
            yAxis: {
                title: {
                    text: obj.left_title
                }
            },
            xAxis: {
              categories: obj.milestone
            },

            plotOptions: {
                series: {
                    marker: {
                        enabled: false,
                        symbol: 'circle',
                        radius: 2
                    },
                    fillOpacity: 0.5
                }
            },
            tooltip: {
                formatter: function() {
                    return '<b>' + this.x + '</b><br>' + this.y.toFixed(obj.decimal) + ' ' + obj.left_title
                }
            },
            series: obj.series,
        
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            },
            exporting : {
                enabled : false
            },
            credits : {
                enabled : false
            }
        }
    },
    SET_MONTHLY_TABLE(state, obj) {
        state.monthly_table = obj
        if (obj.length > 0) {
            state.monthly_total = obj[0].total
        }
    },
    SET_CR_TABLE(state, data){
        state.cr_table = []
        for(let item of data){
            item.provider_type = item.promotion_type
            item.promotion_type = item.promotion_type == 'mobile' ? 'โทรศัพท์เคลื่อนที่' : 'อินเทอร์เน็ตความเร็วสูงประจำที่'
            item.created_at = moment(item.created_at).add(543,'Y').format('DD/MM/YYYY')
            state.cr_table.push(item)
        }
    },
    REMOVE_CR_ITEM(state, item){
        var item_index = state.cr_table.indexOf(item)
        state.cr_table.splice(item_index, 1)
    },
    SET_ITEM_STATUS(state, item){
        var index = state.cr_table.findIndex(i => i.promotion_id == item.promotion_id)
        if(index >= 0) state.cr_table[index].cr_status = item.cr_status
    }
}

function formatPrivilege(privilege) {
    let obj = privilege.data[0]
    let result = {
        data: [],
        type_data: privilege.type_data
    }
    if (obj.content_amount) {
        result.data.push({
            name: "ความบันเทิง",
            amount: obj.content_amount
        });
    }
    if (obj.social_amount) {
        result.data.push({
            name: "โซเชียล",
            amount: obj.social_amount
        });
    }
    if (obj.mobile_amount) {
        result.data.push({
            name: "โทรศัพท์เคลื่อนที่",
            amount: obj.mobile_amount
        });
    }
    if (obj.game_amount) {
        result.data.push({
            name: "เกมส์",
            amount: obj.game_amount
        });
    }
    if (obj.wifi_amount) {
        result.data.push({
            name: "Wifi",
            amount: obj.wifi_amount
        });
    }
    if (obj.premium_amount) {
        result.data.push({
            name: "พรีเมียม",
            amount: obj.premium_amount
        });
    }
    if (obj.device_amount) {
        result.data.push({
            name: "อุปกรณ์",
            amount: obj.device_amount
        });
    }
    if (obj.other_amount) {
        result.data.push({
            name: "อื่นๆ",
            amount: obj.other_amount
        });
    }
    return result;
}

function formatNumber(num) {
    if (num >= 10) {
        var first = Math.floor(num).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        var second = (num % 1 ? (num % 1).toFixed(3) : 0).toString().split('.')[1] || ''
        return first+(num % 1 ? '.' : '')+second
    }
    return num;
}

function formatNumberService(obj) {
    for (let  i = 0;  i < obj.data.length;  i++) {
        switch(obj.data[i].name) {
            case 'all':
                obj.data[i].name = 'ไม่ระบุจำนวนวัน';
                break;
            case '1':
                obj.data[i].name = 'น้อยกว่า 1 วัน';
                break;
            case '5':
                obj.data[i].name = '1-5 วัน';
                break;
            case '10':
                obj.data[i].name = '6-10 วัน';
                break;
            case '15':
                obj.data[i].name = '11-15 วัน';
                break;
            case '30':
                obj.data[i].name = '15-30 วัน';
                break;
            case 'other':
                obj.data[i].name = 'มากกว่า 30 วัน';
        }
    }
    return obj;
}

function formatService(obj) {
    for (let  i = 0;  i < obj.data.length;  i++) {
        switch(obj.data[i].name) {
            case 'all':
                obj.data[i].name = 'เลือกทั้งหมด';
                break;
            case 'content':
                obj.data[i].name = 'บริการความบันเทิง';
                break;
            case 'mobile':
                obj.data[i].name = 'บริการโทรศัพท์เคลื่อนที่';
                break;
            case 'wifi':
                obj.data[i].name = 'บริการ Wifi/Hotspot';
                break;
            case 'fixed':
                obj.data[i].name = 'บริการ Fixed Line';
                break;
            case 'device':
                obj.data[i].name = 'บริการอุปกรณ์อื่นๆ';
                break;
            case 'other':
                obj.data[i].name = 'บริการอื่นๆ';
                break;
        }
    }
    return obj;
}

export const Dashboard = {
    namespaced: true,
    state,
    actions,
    mutations
}